import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    class: "login-content-form",
    ref: "ruleFormsss",
    model: _ctx.ruleForm,
    rules: _ctx.rules
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, { prop: "userName" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "text",
            placeholder: _ctx.$t('message.account.accountPlaceholder1'),
            "prefix-icon": "el-icon-user",
            modelValue: _ctx.ruleForm.userName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.userName) = $event)),
            clearable: "",
            autocomplete: "off"
          }, null, 8, ["placeholder", "modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { prop: "password" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: _ctx.isShowPassword ? 'text' : 'password',
            placeholder: _ctx.$t('message.account.accountPlaceholder2'),
            "prefix-icon": "el-icon-lock",
            modelValue: _ctx.ruleForm.password,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.password) = $event)),
            autocomplete: "off"
          }, {
            suffix: _withCtx(() => [
              _createElementVNode("i", {
                class: _normalizeClass(["iconfont el-input__icon login-content-password", _ctx.isShowPassword ? 'icon-yincangmima' : 'icon-xianshimima']),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowPassword = !_ctx.isShowPassword))
              }, null, 2)
            ]),
            _: 1
          }, 8, ["type", "placeholder", "modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            class: "login-content-submit",
            round: "",
            onClick: _ctx.onSignIn,
            loading: _ctx.loading.signIn
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('message.account.accountBtnText')), 1)
            ]),
            _: 1
          }, 8, ["onClick", "loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}